(function () {
  'use strict';

  const DEBOUNCE_MS = 300;
  const SUGGEST_URL = '/search/suggest.json';
  const SEARCH_URL = '/search';

  // Algolia search-only credentials — PUBLIC (already exposed by the Algolia app's
  // storefront embed; the search-only key is safe to use client-side). Products are
  // served by Algolia so the dropdown ranks machines above accessories and prices
  // are correct; query *suggestions* still come from Shopify (they pre-fill the
  // Algolia-powered /search results page).
  const ALGOLIA_APP_ID = 'MTW285YVQT';
  const ALGOLIA_SEARCH_KEY = '5a599fa6459d57fc3e6f0097cc283565';
  const ALGOLIA_INDEX = 'shopify_products';
  const ALGOLIA_HITS = 6;

  // DOM refs
  const overlay = document.getElementById('cpap-search-overlay');
  if (!overlay) return;

  const input = overlay.querySelector('#cpap-search-input');
  const clearBtn = overlay.querySelector('.cpap-search-clear');
  const submitBtn = overlay.querySelector('.cpap-search-submit');
  const backBtn = overlay.querySelector('.cpap-search-back');
  const resultsWrap = overlay.querySelector('.cpap-search-results');
  const loadingWrap = overlay.querySelector('.cpap-search-loading');
  const emptyWrap = overlay.querySelector('.cpap-search-empty');
  const emptyText = overlay.querySelector('.cpap-search-empty-text');
  const suggestionsList = overlay.querySelector('.cpap-search-suggestions-list');
  const productsList = overlay.querySelector('.cpap-search-products-list');
  const viewAllLink = overlay.querySelector('.cpap-search-view-all');
  const suggestionsHeading = overlay.querySelector('.cpap-search-suggestions .cpap-search-heading');
  const productsHeading = overlay.querySelector('.cpap-search-products .cpap-search-heading');

  let debounceTimer = null;
  let abortController = null;

  // --- Utility ---

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatPrice(amount) {
    // Shopify predictive search (/search/suggest.json) returns prices as DOLLAR
    // strings (e.g. "1450.00"), NOT cents — so parse as a float and DON'T divide
    // by 100. (The old code did /100, turning $1,450.00 into $14.50.)
    const dollars = parseFloat(amount);
    if (isNaN(dollars)) return '';
    return '$' + dollars.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Query the Algolia products index. Prefer the client the storefront embed has
  // already loaded (it tracks key rotation); fall back to a direct REST call.
  function algoliaProducts(query, signal) {
    var as = window.algoliaShopify;
    if (as && as.searchClient && typeof as.searchClient.search === 'function') {
      return as.searchClient
        .search([{ indexName: ALGOLIA_INDEX, query: query, params: { hitsPerPage: ALGOLIA_HITS } }])
        .then(function (r) { return (r.results && r.results[0] && r.results[0].hits) || []; })
        .catch(function () { return []; });
    }
    var url = 'https://' + ALGOLIA_APP_ID + '-dsn.algolia.net/1/indexes/*/queries'
      + '?x-algolia-application-id=' + ALGOLIA_APP_ID
      + '&x-algolia-api-key=' + ALGOLIA_SEARCH_KEY;
    return fetch(url, {
      method: 'POST',
      // form-urlencoded keeps this a CORS-simple request (avoids a preflight)
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: JSON.stringify({ requests: [{ indexName: ALGOLIA_INDEX, query: query, params: 'hitsPerPage=' + ALGOLIA_HITS }] }),
      signal: signal
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (d) { return (d && d.results && d.results[0] && d.results[0].hits) || []; })
      .catch(function () { return []; });
  }

  // --- Open / Close ---

  function openSearch() {
    // Close mobile mega menu if open
    const megaMenuSection = document.querySelector('.shopify-section:has(.cpap-mega-menu-section)');
    if (megaMenuSection) {
      megaMenuSection.classList.remove('show');
      megaMenuSection.querySelectorAll('.dropdown.show').forEach(function (d) {
        d.classList.remove('show');
      });
    }

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cpap-search-open');
    setTimeout(function () {
      input.focus();
    }, 50);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cpap-search-open');
    resetResults();
    input.value = '';
    clearBtn.style.display = 'none';
  }

  function resetResults() {
    resultsWrap.style.display = 'none';
    loadingWrap.style.display = 'none';
    emptyWrap.style.display = 'none';
    suggestionsList.innerHTML = '';
    productsList.innerHTML = '';
  }

  // --- Fetch & Render ---

  function fetchResults(query) {
    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();

    var signal = abortController.signal;
    resetResults();
    loadingWrap.style.display = 'flex';

    // Products from Algolia; query suggestions (refinements) from Shopify.
    var productsP = algoliaProducts(query, signal);
    var suggestUrl = SUGGEST_URL + '?q=' + encodeURIComponent(query)
      + '&resources[type]=query&resources[limit]=4';
    var suggestionsP = fetch(suggestUrl, { signal: signal })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        return (data && data.resources && data.resources.results && data.resources.results.queries) || [];
      })
      .catch(function () { return []; });

    Promise.all([productsP, suggestionsP])
      .then(function (vals) {
        // Ignore a stale response if the user has typed something newer.
        if (input.value.trim() !== query) return;
        loadingWrap.style.display = 'none';

        var products = vals[0] || [];
        var queries = vals[1] || [];

        if (products.length === 0 && queries.length === 0) {
          showEmpty(query);
          return;
        }

        renderSuggestions(queries);
        renderProducts(products);

        // Update "View all results" link
        viewAllLink.href = SEARCH_URL + '?q=' + encodeURIComponent(query);

        resultsWrap.style.display = 'flex';
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        loadingWrap.style.display = 'none';
        showEmpty(query);
      });
  }

  function showEmpty(query) {
    emptyText.textContent = 'No results found for "' + query + '"';
    emptyWrap.style.display = 'flex';
  }

  function renderSuggestions(queries) {
    if (queries.length === 0) {
      suggestionsHeading.style.display = 'none';
      return;
    }
    suggestionsHeading.style.display = '';
    var html = '';
    queries.forEach(function (q) {
      var text = escapeHtml(q.text);
      var url = SEARCH_URL + '?q=' + encodeURIComponent(q.text);
      html += '<li class="cpap-search-suggestion-item">'
        + '<a href="' + url + '">'
        + '<svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 16.5L12.375 12.375M14.25 7.875C14.25 11.3958 11.3958 14.25 7.875 14.25C4.35418 14.25 1.5 11.3958 1.5 7.875C1.5 4.35418 4.35418 1.5 7.875 1.5C11.3958 1.5 14.25 4.35418 14.25 7.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
        + '<span>' + text + '</span>'
        + '</a></li>';
    });
    suggestionsList.innerHTML = html;
  }

  function renderProducts(products) {
    if (products.length === 0) {
      productsHeading.style.display = 'none';
      return;
    }
    productsHeading.style.display = '';
    var html = '';
    products.forEach(function (p) {
      // Algolia hit fields: title, handle, price/compare_at_price (numbers, dollars),
      // image/product_image (Shopify CDN URL).
      var title = escapeHtml(p.title);
      var url = p.url || ('/products/' + p.handle);
      var price = formatPrice(p.price);
      var comparePrice = p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price)
        ? formatPrice(p.compare_at_price)
        : '';
      var rawImg = p.image || p.product_image || '';
      var imgSrc = rawImg
        ? rawImg.replace(/(\.\w+)(\?|$)/, '_200x$1$2')
        : '';

      html += '<li class="cpap-search-product-item">'
        + '<a href="' + url + '">';
      if (imgSrc) {
        html += '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy" width="80" height="80">';
      }
      html += '<div class="cpap-search-product-info">'
        + '<span class="cpap-search-product-title">' + title + '</span>'
        + '<span class="cpap-search-product-price">'
        + '<span class="cpap-search-price-current">' + price + '</span>';
      if (comparePrice) {
        html += '<span class="cpap-search-price-compare">' + comparePrice + '</span>';
      }
      html += '</span></div></a></li>';
    });
    productsList.innerHTML = html;
  }

  // --- Event Listeners ---

  // Trigger buttons (exist in mega menu and mobile header)
  document.querySelectorAll('.btn-open-search').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (overlay.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });
  });

  // Back button (mobile)
  backBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    closeSearch();
  });

  // Input events
  input.addEventListener('input', function () {
    var val = input.value.trim();
    clearBtn.style.display = val.length > 0 ? 'flex' : 'none';

    clearTimeout(debounceTimer);
    if (val.length < 2) {
      resetResults();
      return;
    }
    debounceTimer = setTimeout(function () {
      fetchResults(val);
    }, DEBOUNCE_MS);
  });

  // Clear button
  clearBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    input.value = '';
    clearBtn.style.display = 'none';
    resetResults();
    input.focus();
  });

  // Submit button / Enter key -> go to search page
  function submitSearch() {
    var val = input.value.trim();
    if (val.length > 0) {
      window.location.href = SEARCH_URL + '?q=' + encodeURIComponent(val);
    }
  }

  submitBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    submitSearch();
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      submitSearch();
    }
    if (e.key === 'Escape') {
      closeSearch();
    }
  });

  // Click outside to close (desktop) — click on overlay backdrop
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      closeSearch();
    }
  });

  // Escape key global
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeSearch();
    }
  });
})();
